import { ALLY_PURPLE } from './constants';

export type TransferPartnerConfig = Readonly<{
  partnerId: 'ally' | 'revolut';
  partnerDisplayName: string;
  brandColor: string;
  brandColorHover: string;
  ctaUrl: string;
  /** Cash bonus offered by the partner (e.g. 200 for Ally's $200 offer). */
  bonusAmount?: number;
  /** APY rate displayed for interest-based partners (e.g. '5.50%' for Revolut). */
  apyRate?: string;
}>;

const ALLY_CONFIG: TransferPartnerConfig = {
  partnerId: 'ally',
  partnerDisplayName: 'Ally',
  brandColor: ALLY_PURPLE,
  brandColorHover: '#5a2475',
  ctaUrl: 'https://www.ally.com/',
  bonusAmount: 200,
};

// Placeholder values — update with official Revolut brand assets before launch.
const REVOLUT_CONFIG: TransferPartnerConfig = {
  partnerId: 'revolut',
  partnerDisplayName: 'Revolut',
  brandColor: '#0666EB',
  brandColorHover: '#0452bc',
  ctaUrl: 'https://www.revolut.com/',
  apyRate: '5.50%',
};

const CONFIGS: Record<TransferPartnerConfig['partnerId'], TransferPartnerConfig> = {
  ally: ALLY_CONFIG,
  revolut: REVOLUT_CONFIG,
};

export const getTransferPartnerConfig = (partnerId: string): TransferPartnerConfig | null => CONFIGS[partnerId as TransferPartnerConfig['partnerId']] ?? null;
